module.exports = __webpack_public_path__ + "07_long_black.a2d54231.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/07_long_black.png
// module id = hlcm
// module chunks = 0